import { jsx as _jsx } from "react/jsx-runtime";
import { BenefitPeriods } from '@src/components/Admin/BenefitPeriods';
import { RulesList } from '@src/components/Admin/PolicyBuilder/RulesList';
import { WorkflowsList } from '@src/components/Admin/Workflows';
import { useParams } from 'react-router-dom';
import { Filters } from '../Filters';
import { Populations } from './Populations';
export const PolicyBuilder = () => {
    const { tab = 'populations' } = useParams();
    if (tab === 'populations') {
        return _jsx(Populations, {});
    }
    if (tab === 'workflows') {
        return _jsx(WorkflowsList, {});
    }
    if (tab === 'benefit-periods') {
        return _jsx(BenefitPeriods, {});
    }
    if (tab === 'filters') {
        return _jsx(Filters, {});
    }
    return _jsx(RulesList, {});
};
